import { prepareFormToSubmit } from 'UI/utils/forms';

import { buildResolvedEmailBody } from '../../forms/EmailDetails/EmailDetails.utils';

import { FORM_FIELDS_MAP } from './SendoutForm/SendoutForm.constants';

export const prepareSendoutPayload = ({ formData = {}, jobOrder = {}, resolvedEmailBody = '' }) => {
  const preparedFormData = prepareFormToSubmit(formData, FORM_FIELDS_MAP);

  return {
    ...preparedFormData,
    template: resolvedEmailBody,
    company_id: jobOrder?.company?.id ?? null,
    job_order_id: jobOrder?.id ?? null,
    hiring_authorities: jobOrder?.hiringAuthorities || [],
    // TODO:  type_id, status_id and template_id are harcoded due to the legacy endpoint contract. Will be removed once new endpoint is in place.
    type_id: 1,
    status_id: 1,
    template_id: 3
  };
};

export const buildSendoutSubmissionData = ({
  formData = {},
  jobOrder = {},
  candidateInfo = {}
}) => {
  const { resolvedEmailBody, resolvedTagValues } = buildResolvedEmailBody({
    emailBody: formData[FORM_FIELDS_MAP.EmailBody.key],
    hiringAuthority: formData[FORM_FIELDS_MAP.HiringAuthority.key],
    candidate: formData[FORM_FIELDS_MAP.Candidate.key],
    interviewData: {
      interviewDate: formData[FORM_FIELDS_MAP.InterviewDate.key],
      interviewFromHour: formData[FORM_FIELDS_MAP.InterviewFromHour.key],
      interviewToHour: formData[FORM_FIELDS_MAP.InterviewToHour.key],
      interviewTime: formData[FORM_FIELDS_MAP.InterviewTime.key],
      interviewTimeFrame: formData[FORM_FIELDS_MAP.InterviewTimeFrame.key],
      interviewTimezone: formData[FORM_FIELDS_MAP.InterviewTimezone.key]
    },
    jobOrder,
    candidateInfo
  });

  return {
    payload: prepareSendoutPayload({ formData, jobOrder, resolvedEmailBody }),
    confirmation: {
      resolvedEmailBody,
      resolvedTagValues
    }
  };
};
